import {ReactElement} from 'react'
import PropTypes from 'prop-types'
import {withContext, getContext, hoistStatics, compose, mapProps} from 'recompose'
import Context from '../../config/constants/context'

type DeviceDetectProviderProps = {
  children: ReactElement
  isMobile: boolean
}

export const DeviceDetectProvider = withContext(
  {[Context.IsMobile]: PropTypes.bool},
  (props: DeviceDetectProviderProps) => ({[Context.IsMobile]: props.isMobile})
)(({children}: DeviceDetectProviderProps) => children)

export const withDeviceDetect = hoistStatics<WithDeviceDetectProps>(compose(
  getContext({
    [Context.IsMobile]: PropTypes.bool
  }),
  mapProps(({[Context.IsMobile]: isMobile, ...otherProps}) => ({
    ...otherProps,
    isMobile
  }))
))

export type WithDeviceDetectProps = {
  isMobile: boolean
}
